module.exports = __webpack_public_path__ + "static/media/macButton.44dc68da.png";